import { rest } from 'msw';
import { config } from './fixtures/paymentConfig';

export const paymentConfigHandlers = [
  rest.get('*/re/v1/protocol/:id/rewardConfig',
    (req, res, ctx) => res(
      ctx.status(200),
      ctx.json(config),
    )),
];
